import { render, staticRenderFns } from "./PlayerControlsSeekSlider.vue?vue&type=template&id=4b57f9a6&scoped=true&"
import script from "./PlayerControlsSeekSlider.vue?vue&type=script&lang=js&"
export * from "./PlayerControlsSeekSlider.vue?vue&type=script&lang=js&"
import style0 from "./PlayerControlsSeekSlider.vue?vue&type=style&index=0&id=4b57f9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b57f9a6",
  null
  
)

export default component.exports